// Client-side Stripe helpers.
//
// This app uses Stripe Checkout (redirect) rather than embedded Elements, so
// no publishable key or SDK is needed in the browser. All state-changing
// calls go through Supabase edge functions that hold STRIPE_SECRET_KEY.
//
// `VITE_STRIPE_MODE` distinguishes test vs live in the UI (banner, subscription
// queries). It is set to "test" in .env.development and "live" in .env.production.

export type StripeEnv = "test" | "live";

export function getStripeEnvironment(): StripeEnv {
  const raw = (import.meta.env.VITE_STRIPE_MODE as string | undefined) ?? "test";
  return raw === "live" ? "live" : "test";
}
